import { JsonObject, JsonProperty } from 'json2typescript';
import { CurrencyInterface } from '../interfaces/currency.interface';

@JsonObject('Currency')
export class Currency implements CurrencyInterface {
  symbol?: string;
  symbolPosition?: string;
  decimalSeparator?: string;
  groupSeparator?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
